import { useNavigate } from 'react-router-dom'
import { CardPageLayout, CardPageLegalLinks } from '@/components/card-page-layout/CardPageLayout'
import signOutOfApp from '@/firebase/auth/sign-out'

export default function AccountSetupFlow() {
  const navigate = useNavigate()

  return (
    <CardPageLayout footer={<CardPageLegalLinks />} onSignOut={() => signOutOfApp(navigate)}>
      <div className="flex flex-col gap-1.5 text-center">
        <h1 className="font-rethink-sans text-xl font-semibold leading-7 text-brand-neutral-950">Confirm your details</h1>
        <p className="text-base text-brand-neutral-950">Help us personalize your experience.</p>
      </div>
    </CardPageLayout>
  )
}
